<template>
    <div>
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Uso de assinaturas e consultas</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home">
                            <router-link to="/home"><i class="fa fa-home"></i></router-link>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item">
                            <a href="#" @click.prevent="EditCancel()">Uso de Assinaturas e Consultas</a>
                        </li>
                    </ul>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card gp-report-card">
                            <div class="card-body">
                                <div class="row gp-report-filters">
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <v-autocomplete v-model="GarantidoraSelected" :items="Garantidoras" item-title="garNomeEmpresa" item-value="garId"
                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhum registro encontrado" :disabled="User.garid != 0" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Data Inicial</label>
                                            <input v-model="DataInicial" type="date" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Data Final</label>
                                            <input v-model="DataFinal" type="date" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <button type="button" class="btn btn-info" style="color:#ffffff;margin-top: 35px;" @click="Pesquisar()">
                                            Pesquisar
                                        </button>
                                    </div>
                                </div>

                                <div class="row" style="padding-top: 20px;">
                                    <div class="col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <p class="card-category">Consultas usadas</p>
                                                <h4 class="card-title">{{ Resumo.totalConsultasRealizadas }}</h4>
                                                <span>de {{ Resumo.totalConsultasContratadas }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <p class="card-category">Saldo consultas</p>
                                                <h4 class="card-title">{{ Resumo.saldoConsultas }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <p class="card-category">Assinaturas usadas</p>
                                                <h4 class="card-title">{{ Resumo.totalAssinaturasRealizadas }}</h4>
                                                <span>de {{ Resumo.totalAssinaturasContratadas }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <p class="card-category">Saldo assinaturas</p>
                                                <h4 class="card-title">{{ Resumo.saldoAssinaturas }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="padding-top: 20px;padding-bottom: 20px;">
                                    <hr>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="d-flex align-items-center">
                                            <h4 class="card-title">Detalhamento</h4>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" md="6" style="text-align: right;padding-right: 15px;">
                                                <button @click="exportXLSX()" class="btn btn-warning">Exportar XLSX</button>
                                            </v-col>
                                        </v-row>

                                        <adm-data-table
                                            :headers="headers"
                                            :items="ListResult"
                                            v-model="itemsSelected"
                                            :show-filters="false"
                                            :show-export="true"
                                            file-name="uso-assinaturas-consultas"
                                            alternating
                                            theme-color="#364f66"
                                            table-class-name="customize-table"
                                            header-text-direction="center"
                                            body-text-direction="center"
                                            rows-per-page-message="Linhas por pagina"
>
                                            <template #item-dataUso="item">
                                                <span>{{ formattedDate(item.dataUso) }}</span>
                                            </template>
                                            <template #item-pedidoId="item">
                                                <span>{{ item.pedidoId || '' }}</span>
                                            </template>
                                        </adm-data-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import * as XLSX from 'xlsx';

export default {
    name: 'RelatorioUsoConsultasAssinaturasView',
    components: {
        EasyDataTable
    },
    data: () => ({
        User: {
            garid: 0,
            tpeid: 0,
            pesid: 0
        },
        GarantidorasGeral: [],
        Garantidoras: [],
        GarantidoraSelected: null,
        DataInicial: '',
        DataFinal: '',
        searchValue: '',
        itemsSelected: [],
        ListResult: [],
        Resumo: {
            totalConsultasRealizadas: 0,
            totalAssinaturasRealizadas: 0,
            totalConsultasContratadas: 0,
            totalAssinaturasContratadas: 0,
            saldoConsultas: 0,
            saldoAssinaturas: 0
        },
        headers: []
    }),
    methods: {
        formattedDate(value) {
            if (value != null && value !== "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            return "";
        },
        EditCancel() {
            this.$router.go(0);
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "Data", value: "dataUso", sortable: true });
            this.headers.push({ text: "Tipo", value: "tipoUso", sortable: true });
            this.headers.push({ text: "Origem", value: "origem", sortable: true });
            this.headers.push({ text: "Pedido", value: "pedidoId", sortable: true });
            this.headers.push({ text: "Garantidora", value: "garNome", sortable: true });
            this.headers.push({ text: "Imobiliaria", value: "imobNome", sortable: true });
            this.headers.push({ text: "Cliente", value: "cliNome", sortable: true });
            this.headers.push({ text: "Documento", value: "documento", sortable: true });
            this.headers.push({ text: "Situacao", value: "situacaoPedido", sortable: true });
            this.headers.push({ text: "Identificador", value: "identificador", sortable: true });
        },
        async Pesquisar() {
            if (this.GarantidoraSelected === null || this.GarantidoraSelected === '' || this.GarantidoraSelected === 0) {
                this.$mensagemAviso("Campo Garantidora Obrigatorio.");
                return;
            }

            if (this.DataInicial === '' || this.DataFinal === '') {
                this.$mensagemAviso("Periodo Obrigatorio.");
                return;
            }

            if (this.$moment(this.DataFinal).isBefore(this.$moment(this.DataInicial))) {
                this.$mensagemAviso("Data Final nao pode ser menor que Data Inicial.");
                return;
            }

            try {
                const response = await axios.get(`/Telas/RelatorioUsoConsultasAssinaturas/Pesquisar`, {
                    params: {
                        garId: this.GarantidoraSelected,
                        dataInicial: this.DataInicial,
                        dataFinal: this.DataFinal
                    }
                });

                this.Resumo = {
                    totalConsultasRealizadas: response.data.totalConsultasRealizadas,
                    totalAssinaturasRealizadas: response.data.totalAssinaturasRealizadas,
                    totalConsultasContratadas: response.data.totalConsultasContratadas,
                    totalAssinaturasContratadas: response.data.totalAssinaturasContratadas,
                    saldoConsultas: response.data.saldoConsultas,
                    saldoAssinaturas: response.data.saldoAssinaturas
                };
                this.ListResult = response.data.itens || [];
            } catch (error) {
                const msg = error?.response?.data?.message || "Erro ao pesquisar relatorio.";
                this.$mensagemAviso(msg);
            }
        },
        exportXLSX() {
            if (!this.ListResult || this.ListResult.length === 0) {
                alert("Nao ha dados para exportar.");
                return;
            }

            const rows = this.ListResult.map(item => ({
                Data: item.dataUso ? this.$moment(item.dataUso).format('DD/MM/YYYY') : '',
                Tipo: item.tipoUso || '',
                Origem: item.origem || '',
                Pedido: item.pedidoId || '',
                Garantidora: item.garNome || '',
                Imobiliaria: item.imobNome || '',
                Cliente: item.cliNome || '',
                Documento: item.documento || '',
                Situacao: item.situacaoPedido || '',
                Identificador: item.identificador || ''
            }));

            const ws = XLSX.utils.json_to_sheet(rows);
            ws['!cols'] = [
                { wch: 12 },
                { wch: 14 },
                { wch: 28 },
                { wch: 12 },
                { wch: 28 },
                { wch: 28 },
                { wch: 30 },
                { wch: 20 },
                { wch: 22 },
                { wch: 34 }
            ];

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Uso');
            XLSX.writeFile(wb, 'RelatorioUsoConsultasAssinaturas.xlsx', { compression: true });
        }
    },
    async created() {
        this.montaGrid();

        const hoje = this.$moment();
        this.DataInicial = hoje.clone().startOf('month').format('YYYY-MM-DD');
        this.DataFinal = hoje.format('YYYY-MM-DD');

        await axios.get(`/Telas/RelatorioUsoConsultasAssinaturas/GetDados`)
            .then(response => {
                this.User.garid = response.data.garId;
                this.User.tpeid = response.data.tpeId;
                this.User.pesid = response.data.pesId;

                this.GarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
                    a.garNomeEmpresa.localeCompare(b.garNomeEmpresa, 'pt', { sensitivity: 'base' })
                );

                if (this.User.garid != 0) {
                    this.Garantidoras = this.GarantidorasGeral.filter(x => x.garId == this.User.garid);
                    this.GarantidoraSelected = this.User.garid;
                } else {
                    this.Garantidoras = this.GarantidorasGeral;
                }
            });
    }
}
</script>
